import React, {Component} from "react";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default class PasswordInput extends Component {

    static propTypes = {
        className: PropTypes.string,
        name: PropTypes.string,
        value: PropTypes.string,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {visible: false};
    }

    toggleVisibility = () => {
        this.setState(state => ({visible: !state.visible}));
    };

    render() {
        const {className, ...rest} = this.props;
        const {visible} = this.state;

        return (
            <div className="password-input" style={{position: "relative"}}>
                <input
                    {...rest}
                    type={visible ? "text" : "password"}
                    className={className}
                    style={{paddingRight: "2.25rem", width: "100%"}}
                />
                <button
                    type="button"
                    tabIndex={-1}
                    onClick={this.toggleVisibility}
                    aria-label={visible ? "Hide password" : "Show password"}
                    style={{
                        position: "absolute",
                        top: "50%",
                        right: "0.5rem",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                        color: "#6c757d",
                        lineHeight: 1,
                    }}
                >
                    <FontAwesomeIcon icon={visible ? "eye-slash" : "eye"}/>
                </button>
            </div>
        );
    }
}
